/**
 * Canonical legal copy for the public website. The Flutter app ships an
 * embedded mirror of this text (see lib/screens/legal/legal_screen.dart)
 * so reviewers can read it without a network connection — the two MUST
 * stay in sync whenever a clause changes.
 */

export const TERMS_UPDATED = "30 Temmuz 2026";
export const PRIVACY_UPDATED = "30 Temmuz 2026";

export const TERMS_SECTIONS: Array<[string, string]> = [
  [
    "1. Uygulama Hakkında",
    "Kelime Yarışı, gerçek zamanlı olarak iki oyuncunun Türkçe kelimelerle düello yapmasına olanak tanıyan bir mobil oyundur. Hizmeti kullanarak bu koşulları kabul etmiş olursun.",
  ],
  [
    "2. Hesap ve Yaş",
    "Hizmetten yararlanmak için en az 13 yaşında olman gerekir. Yaşın 13’ün altındaysa yasal vasinin onayı olmadan hesap oluşturma. Hesabının güvenliği (şifre, doğrulama kodu) senin sorumluluğundadır.",
  ],
  [
    "3. Adil Oyun",
    "Otomatik araç, bot, üçüncü taraf istemci veya başka oyuncuyu taciz eden, tehdit eden ya da yanıltan davranışlar yasaktır. Kuralları ihlal eden hesaplar uyarısız kapatılabilir.",
  ],
  [
    "4. Sanal Ürünler",
    "Uygulama içinde “elmas” ve “can” adında sanal para birimleri bulunur. Bunların gerçek para değeri yoktur; hesapla birlikte silinirler ve iade edilemezler (tüketici mevzuatının izin verdiği durumlar hariç).",
  ],
  [
    "5. Reklamlar",
    "Uygulamada Google AdMob aracılığıyla ödüllü reklamlar gösterilir. Reklam izlemek tamamen isteğe bağlıdır; izlemeyi seçtiğinde karşılığında can kazanırsın. Saatte en fazla 5 ödüllü reklam izlenebilir. Reklamı sonuna kadar izlemeden kapatırsan ödül verilmez. Reklam içerikleri Google tarafından sunulur; içerikten geliştirici sorumlu değildir. Reklamların nasıl kişiselleştirildiği ve onayını nasıl değiştirebileceğin Gizlilik Politikası’nın “Reklamlar ve Onay” bölümünde açıklanmıştır.",
  ],
  [
    "6. Fikri Mülkiyet",
    "Kelime Yarışı uygulama adı, logosu ve tasarımı telif hakları ile korunur. Kelime veritabanı Türkçe sözlüklerden derlenmiştir.",
  ],
  [
    "7. Sorumluluğun Sınırlandırılması",
    "Hizmet “olduğu gibi” sunulur. Geliştirici, servis kesintileri veya veri kaybı nedeniyle oluşabilecek dolaylı zararlardan yasal olarak sorumlu tutulamaz.",
  ],
  [
    "8. Hesap Silme",
    "Uygulama içi Ayarlar > Hesabı Sil menüsünden hesabını ve ilişkili tüm verini kalıcı olarak silebilirsin. Silme işlemi geri alınamaz.",
  ],
  [
    "9. Değişiklikler",
    "Bu koşullar güncellendiğinde, önemli değişiklikler için uygulama içi bildirim gönderilir. Güncel sürümü kabul etmemen halinde hizmeti kullanmayı bırakman gerekir.",
  ],
  [
    "10. İletişim",
    "Sorular için: info@zyronajans.com adresine yazabilirsin.",
  ],
];

export const PRIVACY_SECTIONS: Array<[string, string]> = [
  [
    "1. Kim Olduğumuz",
    "Kelime Yarışı, bu uygulamanın geliştiricisi olarak kişisel verilerinin denetleyicisidir. Sorularını info@zyronajans.com adresine yönlendirebilirsin.",
  ],
  [
    "2. Topladığımız Veriler",
    [
      "• Hesap bilgileri: e-posta (varsa), Google/Apple kullanıcı ID, telefon numarası (telefonla giriş için), oyuncu adı.",
      "• Oyun verileri: galibiyet/mağlubiyet, elmas/can sayısı, maç geçmişi (rakip adı ve skor), galibiyet serisi.",
      "• Teknik veriler: FCM push token, platform (Android/iOS), uygulama sürümü, çökme raporları (Crashlytics), anonim analiz (Firebase Analytics).",
      "• Reklam verileri: Google Reklam Kimliği (Advertising ID), ülke/bölge düzeyinde yaklaşık konum, cihaz bilgisi ve reklam etkileşimleri — reklamları sunmak, ölçmek ve sahte ödül taleplerini engellemek için Google AdMob tarafından işlenir.",
    ].join("\n"),
  ],
  [
    "3. Nasıl Kullanıyoruz",
    "Toplanan veriler yalnızca hizmeti sunmak (eşleştirme, istatistik, bildirim), ödüllü reklam göstermek, güvenliği sağlamak (hile/kötüye kullanım tespiti), uygulamayı iyileştirmek (çökme analizi) ve yasal yükümlülükleri karşılamak için kullanılır.",
  ],
  [
    "4. Paylaştıklarımız",
    "Kişisel verin kiralanmaz veya satılmaz. İsmin ve skorun — hesap oluştururken kabul ettiğin gibi — liderlik tablosunda ve rakip önizlemesinde diğer oyunculara görünür. Teknik işleyici olarak Google Firebase (Auth, Firestore, Messaging, Crashlytics, Analytics) ve reklam sunumu için Google AdMob ile çalışıyoruz.",
  ],
  [
    "5. Reklamlar ve Onay",
    [
      "Uygulamada Google AdMob aracılığıyla ödüllü reklamlar gösterilir. AdMob, reklamları sunmak ve ölçmek için Google Reklam Kimliği ve benzeri tanımlayıcıları kullanır.",
      "Avrupa Ekonomik Alanı, Birleşik Krallık, İsviçre ve Kaliforniya’daki kullanıcılara ilk açılışta Google’ın onay formu (UMP) gösterilir. Kişiselleştirilmiş reklamları reddedebilirsin; bu durumda reklamlar kişiselleştirilmeden gösterilmeye devam eder.",
      "Onayın gerekli olduğu bölgelerde tercihini istediğin zaman Ayarlar ekranından değiştirebilirsin. Ayrıca cihazının sistem ayarlarından Reklam Kimliğini sıfırlayabilir veya tamamen silebilirsin.",
    ].join("\n"),
  ],
  [
    "6. Çocukların Gizliliği",
    "Uygulama 13 yaş altı çocuklara yönelik olarak tasarlanmamıştır. 13 yaş altı bir kullanıcıdan kasıtlı olarak veri toplamayız. Böyle bir durum fark ettiğinde info@zyronajans.com üzerinden bize bildirirsen 30 gün içinde ilgili veri silinir.",
  ],
  [
    "7. Saklama Süresi",
    "Hesap verin, hesap silme talebi oluşturulana kadar saklanır. Silme işlemi hesabı ve ilişkili tüm oyun verisini geri dönüşsüz şekilde kaldırır. Güvenlik amacıyla tutulan teknik kayıtlar (ör. şikayet kayıtları) en fazla 12 ay saklanır.",
  ],
  [
    "8. Haklarınız (KVKK & GDPR)",
    "Kişisel verine erişme, düzeltme, silme, işlemeye itiraz etme ve veri taşınabilirliği haklarına sahipsin. Bu haklar için info@zyronajans.com adresine başvurabilirsin. Ayrıca şikayetini yetkili veri koruma kurumuna (Türkiye için KVKK, AB için yerel DPA) iletebilirsin.",
  ],
  [
    "9. Güvenlik",
    "Tüm ağ trafiği HTTPS üzerinden şifrelenir. Sunucularımız Google Cloud üzerinde barındırılır ve erişim yalnızca yetkili personelle sınırlıdır. Buna rağmen hiçbir sistemin %100 güvenli olmadığını kabul ediyoruz.",
  ],
  [
    "10. Değişiklikler",
    "Bu politikada önemli bir değişiklik olduğunda, yürürlük tarihinden en az 7 gün önce uygulama içinde bildirim göstereceğiz.",
  ],
];
